import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { requestPasswordReset } from "api";
import { Spinner } from "components/common";

export default function ForgotPasswordPage() {
  const navigate       = useNavigate();
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const { mutate, isPending, error } = useMutation({
    mutationFn: () => requestPasswordReset(email),
    onSuccess:  () => setSubmitted(true),
  });

  if (submitted) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
        <div className="card w-full max-w-sm p-8 text-center space-y-4">
          <h1 className="text-base font-semibold text-gray-900">Check your email</h1>
          <p className="text-sm text-gray-500">
            If an account exists for <span className="font-medium text-gray-700">{email}</span>,
            you'll receive a password reset link shortly.
          </p>
          <button className="btn-primary w-full" onClick={() => navigate("/login")}>
            Back to sign in
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="card w-full max-w-sm p-8">
        <div className="text-center mb-8">
          <h1 className="text-xl font-semibold text-brand-600">Bridge 13</h1>
          <p className="text-sm text-gray-500 mt-1">Reset your password</p>
        </div>

        <form onSubmit={(e) => { e.preventDefault(); mutate(); }} className="space-y-4">
          <div>
            <label className="label">Email</label>
            <input
              type="email"
              className="input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              required
              autoFocus
            />
          </div>

          {error && (
            <p className="text-sm text-red-500">Something went wrong. Please try again.</p>
          )}

          <button type="submit" className="btn-primary w-full" disabled={isPending}>
            {isPending ? <Spinner className="h-4" /> : "Send reset link"}
          </button>
        </form>

        <button
          onClick={() => navigate("/login")}
          className="mt-4 text-xs text-gray-400 hover:text-brand-600 w-full text-center transition-colors"
        >
          Back to sign in
        </button>
      </div>
    </div>
  );
}
